import { render } from "./ModelName.vue?vue&type=template&id=4512084e"
import script from "./ModelName.vue?vue&type=script&lang=js"
export * from "./ModelName.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__